import { Trans, useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom';

export default function BlogsSection({dir}) {
  const { t, i18n } = useTranslation();
  const hoverContentStyle = {
    transform: dir === 'rtl' ? 'translate(-50%, -50%)' : 'translate(50%, -50%)',
  };
  return <>
  
      <div className="row  justify-content-evenly ">
        <div className="col-md-11 headlineContainer wow fadeInLeft" data-wow-delay="0.3s">
          <h2 className='Title px-2 my-4' >
             <div className='indicator'></div>                       
            <Trans i18nKey="BlogsTitle">مقالات قانونية تثري معرفتك</Trans>
          </h2>
        </div>
        <div className="col-md-11 d-flex align-items-center justify-content-center">
          <div className="row align-items-center g-4 justify-content-between w-100 wow fadeIn px-2" data-wow-delay="0.6s">
            <div className="col-lg-6 col-xl-5 h-100 Blogs position-relative">
              <h3 className='subtitle2 mx-2 mx-lg-3'><Trans i18nKey="HomeBlogTitle">صياغة العقود القانونية – أسس وضوابط تحمي حقوق الأطراف</Trans></h3>

              <div className="blog-hover-content" style={hoverContentStyle}>
                <div className="hover-inner bg-white p-4 rounded shadow-lg">
                  <h4 className="hover-title  mb-3"><Trans i18nKey="HomeBlogTitle">صياغة العقود القانونية – أسس وضوابط تحمي حقوق الأطراف</Trans></h4>
                  <p className="hover-text text-muted mb-4 clamped-text2">
                    <Trans i18nKey="HomeBlogDecribtion" >   تلعب العقود القانونية دورًا محوريًا في تحديد حقوق والتزامات الأطراف المتعاقدة، مما يساعد في تفادي النزاعات القانونية المحتملة. نناقش في هذا المقال أبرز الأسس والضوابط التي يجب مراعاتها عند ......
                    </Trans>
                  </p>
                  <div className="row">
                    <div className="col-md-12 d-flex  justify-content-end">
                      <button className="HeroBtn p-2 px-3 d-flex align-items-center rounded-0" style={{ fontSize: "15px" }}>
                        <Link to='/info/Blogs' style={{ textDecoration: "none", color: "white" }}><Trans i18nKey="ContinueReadingBtn">تابع القراءة </Trans></Link>
                        <i className={dir === 'ltr' ? 'fa-solid fa-chevron-right px-2' : 'fa-solid fa-chevron-left px-2'}></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <h3 className='HomeBlogsTitle mb-3'><Trans i18nKey="HomeBlogsTitle">اكتشف عالم القانون عن قرب! </Trans></h3>
              <h4 className="caption">
                <Trans i18nKey="BlogsCaption"
                />
              </h4>
              
            <div className="col-md-12 d-flex justify-content-end my-5">
             <button className='secondary_btn py-3 px-3'>
               <Link className='VisitBlog text-center' to={"/info/Blogs"}><Trans i18nKey="VisitBlog">زر المدونة وابقَ على معرفة
              </Trans>
              <i className={dir === 'ltr' ? 'fa-solid fa-chevron-right px-2' : 'fa-solid fa-chevron-left px-2'}></i></Link>
             </button>
            </div>
            </div>
          </div>
        </div>
      </div>
    </>
}
